<div class="dialog-holder">
    <aku-qr-code *ngIf="signUrl" data="{{signUrl}}"></aku-qr-code>
    <button (click)="dialogRef.close()" mat-raised-button>Stäng</button>
</div>
